import { Store } from '@/modules/retailer/models/Store';
import { BuildingStorefrontIcon, ChevronRightIcon, PhoneIcon } from '@heroicons/react/24/outline';

const StoreCard = ({
  store,
  selected,
  onSelect,
}: {
  store: Store;
  selected: boolean;
  onSelect: () => void;
}) => {
  const inactive = store.status && store.status !== 'ACTIVE';

  return (
    <button
      type="button"
      onClick={onSelect}
      data-testid="retailer-store-card"
      data-store-id={store.id}
      className={`
        h-full
        bg-white text-left rounded-xl border p-4 shadow-sm transition
        focus:outline-none focus:ring-2 focus:ring-gray-200
        ${selected ? 'border-gray-900 ring-1 ring-gray-900' : 'border-gray-200 hover:border-brand-accent'}
        ${inactive ? 'opacity-80' : ''}
      `}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0 space-y-3">
          <div className="flex items-center gap-2">
            <BuildingStorefrontIcon className="w-5 h-5 text-gray-600" />
            <h3 className="text-base font-semibold text-gray-900 truncate">{store.name}</h3>
          </div>

          <div className="flex items-center gap-2 h-6">
            {store.externalCode && (
              <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700">
                {store.externalCode}
              </span>
            )}

            {store.status && (
              <span
                className={`
                  inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium
                  ${
                    store.status === 'ACTIVE'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-gray-200 text-gray-800'
                  }
                `}
              >
                {store.status === 'ACTIVE' ? 'Active' : 'Inactive'}
              </span>
            )}
          </div>

          <div className="flex items-center gap-2 text-sm text-gray-600 h-5">
            {store.contactNumber && (
              <>
                <PhoneIcon className="w-4 h-4" />
                <span>{store.contactNumber}</span>
              </>
            )}
          </div>

          <div className="text-sm text-gray-700 min-h-[2.5rem]">
            {store.description && (
              <p className="line-clamp-2 whitespace-pre-line">{store.description}</p>
            )}
          </div>
        </div>

        <ChevronRightIcon className="w-5 h-5 text-gray-400 shrink-0" />
      </div>
    </button>
  );
};

export default StoreCard;
